module.exports = __webpack_public_path__ + "static/media/smartswitch.fec4395e.png";